import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-625925f0"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mb-[20px]" }, "優惠活動", -1))
const _hoisted_2 = { class: "flex justify-between items-center mb-[26px]" }
const _hoisted_3 = { class: "w-full pr-2 sm:pr-0 sm:w-[320px]" }
const _hoisted_4 = {
  key: 0,
  class: "max-h-[500px] flex flex-col mt-[30px] gap-2.5 overflow-auto"
}
const _hoisted_5 = {
  key: 1,
  class: "max-h-[350px] flex flex-col mt-[30px] gap-2.5 overflow-auto"
}
const _hoisted_6 = { class: "flex flex-col h-[104px] justify-center" }
const _hoisted_7 = { class: "text-xs text-gary-text-color" }
const _hoisted_8 = { class: "text-xs text-gary-text-color" }
const _hoisted_9 = {
  key: 0,
  class: "text-[11px] text-light-gary-text-color"
}
const _hoisted_10 = {
  key: 1,
  class: "text-[11px] text-secondary-color"
}
const _hoisted_11 = {
  key: 2,
  class: "text-xs text-gary-line-color mt-[12px]"
}
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" 單筆訂單限抵一張折價券。")
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" 取消訂單、辦理整筆退貨或退貨後之保留商品未符合折價券使用條件時，若折價券能仍在使用期限內，將歸還至帳戶中。 ")
const _hoisted_15 = [
  _hoisted_12,
  _hoisted_13,
  _hoisted_14
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!
  const _component_Input = _resolveComponent("Input")!
  const _component_Tabs = _resolveComponent("Tabs")!
  const _component_Divider = _resolveComponent("Divider")!
  const _component_ActivityComponent = _resolveComponent("ActivityComponent")!
  const _component_ModalBase = _resolveComponent("ModalBase")!

  return (_openBlock(), _createBlock(_component_ModalBase, {
    ref: "modalElement2",
    show: _ctx.show,
    class: "modal-510-width",
    onClose: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('update:show', false)))
  }, {
    body: _withCtx(() => [
      _createElementVNode("div", null, [
        _createVNode(_component_Icon, {
          iconName: "modal-close",
          class: "absolute top-4 right-4 cursor-pointer",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:show', false)))
        }),
        _hoisted_1,
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_Input, {
              class: "w-full",
              width: '100%',
              placeholder: "請輸入優惠代碼",
              modelValue: _ctx.promotionCode,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.promotionCode) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", {
            class: "bg-gary-text-color text-sm text-white w-[60px] h-[40px] text-center leading-[40px] rounded-md cursor-pointer",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.redeemCode()))
          }, " 確認 ")
        ]),
        _createVNode(_component_Tabs, {
          data: [
            { id: 1, text: '限定活動' },
            { id: 2, text: '優惠券' }
          ],
          customClass: 'custom-coupon-tabs',
          onTabSelect: _ctx.tabSelect
        }, null, 8, ["onTabSelect"]),
        _createElementVNode("div", null, [
          _createVNode(_component_Divider)
        ]),
        (_ctx.tabSelected === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activityList, (activity, index) => {
                return (_openBlock(), _createElementBlock("div", { key: index }, [
                  _createVNode(_component_ActivityComponent, {
                    activityInfo: activity,
                    style: {"cursor":"pointer"},
                    onClick: ($event: any) => (_ctx.clickActivity(activity))
                  }, null, 8, ["activityInfo", "onClick"])
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        (_ctx.tabSelected === 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cmdyCouponList, (cmdyCoupon, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: _normalizeClass(["w-full flex justify-between px-[16px] rounded-md border-[1px] border-black-300-color", {
              'border-black-300-color': !cmdyCoupon.IsUsing,
              'border-primary-color': cmdyCoupon.IsUsing,
              'bg-black-200-color':
                !cmdyCoupon.IsAvailable && !cmdyCoupon.IsUsing,
            }])
                }, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, _toDisplayString(cmdyCoupon.PromotionCouponName), 1),
                    _createElementVNode("div", _hoisted_8, _toDisplayString(cmdyCoupon.PromotionCouponDescription), 1),
                    (!_ctx.calcDateIsLimit(cmdyCoupon.EffectiveDateEnd))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_9, " 有效期限：" + _toDisplayString(_ctx.moment
                    .utc(
                      _ctx.moment
                        .utc(cmdyCoupon.EffectiveDateEnd, "YYYYMMDDHHmmss")
                        .local()
                    )
                    .format("YYYY/MM/DD")), 1))
                      : _createCommentVNode("", true),
                    (_ctx.calcDateIsLimit(cmdyCoupon.EffectiveDateEnd))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_10, " 即將失效：" + _toDisplayString(_ctx.calcLimitTime(cmdyCoupon.EffectiveDateEnd)), 1))
                      : _createCommentVNode("", true)
                  ])
                ], 2))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        (_ctx.tabSelected === 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, _hoisted_15))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["show"]))
}